__turbopack_context__.v({
  "autoplay": "Control-module-scss-module__S2lB_a__autoplay",
  "overlay": "Control-module-scss-module__S2lB_a__overlay",
  "pause": "Control-module-scss-module__S2lB_a__pause",
  "play": "Control-module-scss-module__S2lB_a__play",
  "playing": "Control-module-scss-module__S2lB_a__playing",
});
